import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const purchases = [{
  name: 'Martín G.',
  city: 'Buenos Aires',
  initials: 'MG',
  color: 'bg-blue-100 text-blue-600'
}, {
  name: 'Laura P.',
  city: 'Córdoba',
  initials: 'LP',
  color: 'bg-purple-100 text-purple-600'
}, {
  name: 'Roberto M.',
  city: 'Mendoza',
  initials: 'RM',
  color: 'bg-pink-100 text-pink-600'
}, {
  name: 'Cecilia R.',
  city: 'Rosario',
  initials: 'CR',
  color: 'bg-green-100 text-green-600'
}, {
  name: 'Sofía C.',
  city: 'Córdoba',
  initials: 'SC',
  color: 'bg-orange-100 text-orange-600'
}, {
  name: 'Pablo A.',
  city: 'Mendoza',
  initials: 'PA',
  color: 'bg-indigo-100 text-indigo-600'
}, {
  name: 'Marcela G.',
  city: 'Neuquén',
  initials: 'MG',
  color: 'bg-rose-100 text-rose-600'
}, {
  name: 'Diego F.',
  city: 'La Plata',
  initials: 'DF',
  color: 'bg-teal-100 text-teal-600'
}, {
  name: 'Valentina R.',
  city: 'Salta',
  initials: 'VR',
  color: 'bg-yellow-100 text-yellow-700'
}, {
  name: 'Federico L.',
  city: 'Mar del Plata',
  initials: 'FL',
  color: 'bg-cyan-100 text-cyan-600'
}, {
  name: 'Camila B.',
  city: 'Tucumán',
  initials: 'CB',
  color: 'bg-fuchsia-100 text-fuchsia-600'
}, {
  name: 'Nicolás P.',
  city: 'Bariloche',
  initials: 'NP',
  color: 'bg-emerald-100 text-emerald-600'
}, {
  name: 'Florencia S.',
  city: 'San Juan',
  initials: 'FS',
  color: 'bg-violet-100 text-violet-600'
}, {
  name: 'Lucas D.',
  city: 'Mendoza',
  initials: 'LD',
  color: 'bg-amber-100 text-amber-600'
}, {
  name: 'Agustina M.',
  city: 'Buenos Aires',
  initials: 'AM',
  color: 'bg-sky-100 text-sky-600'
}];
const timeOptions = ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 18 minutos', 'hace 25 minutos', 'hace 1 hora', 'hace 2 horas'];
type Notification = {
  id: number;
  name: string;
  city: string;
  initials: string;
  color: string;
  time: string;
};
export function PurchaseNotification() {
  const [current, setCurrent] = useState<Notification | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: ReturnType<typeof setTimeout>;
    let hideTimeoutId: ReturnType<typeof setTimeout>;
    let counter = 0;
    const showNotification = () => {
      const purchase = purchases[Math.floor(Math.random() * purchases.length)];
      const time = timeOptions[Math.floor(Math.random() * timeOptions.length)];
      counter += 1;
      setCurrent({
        id: counter,
        ...purchase,
        time
      });
      // hide after 5s
      hideTimeoutId = setTimeout(() => {
        setCurrent(null);
        // schedule next
        timeoutId = setTimeout(showNotification, 8000 + Math.random() * 7000);
      }, 5000);
    };
    // first notification after 6 seconds
    timeoutId = setTimeout(showNotification, 6000);
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(hideTimeoutId);
    };
  }, [dismissed]);
  return <div className="fixed bottom-4 left-4 z-40 pointer-events-none md:bottom-6 md:left-6" data-id="element-225">
      <AnimatePresence data-id="element-226">
        {current && !dismissed && <motion.div key={current.id} initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="pointer-events-auto bg-white rounded-2xl shadow-2xl border border-gray-100 p-3 pr-8 flex items-center gap-3 max-w-[300px] relative mb-20 md:mb-0" data-id="element-227">
            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-1.5 right-1.5 text-gray-300 hover:text-gray-500 transition-colors" data-id="element-228">
              <X className="w-3.5 h-3.5" data-id="element-229" />
            </button>

            <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm shrink-0 ${current.color}`} data-id="element-230">
              {current.initials}
            </div>

            <div className="flex-1 min-w-0" data-id="element-231">
              <div className="flex items-center gap-1 text-[11px] font-semibold text-green-600 mb-0.5" data-id="element-232">
                <ShoppingBag className="w-3 h-3" data-id="element-233" />
                <span data-id="element-234">COMPRA VERIFICADA</span>
              </div>
              <p className="text-sm text-gray-900 leading-tight" data-id="element-235">
                <span className="font-bold" data-id="element-236">{current.name}</span>
                <span className="text-gray-500" data-id="element-237"> de {current.city}</span>
              </p>
              <p className="text-[11px] text-gray-400 mt-0.5" data-id="element-238">
                Megapack Operativo · {current.time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}